import React from 'react';
import { Menu, Search } from 'lucide-react';
import UserMenu from './UserMenu';
import { useAuth } from '../../hooks/useAuth';

interface TopAppBarProps {
  onMenuClick: () => void;
}

const TopAppBar: React.FC<TopAppBarProps> = ({ onMenuClick }) => {
  const { org } = useAuth();
  const orgName = org?.name || 'Institutional Curator';

  return (
    <header className="sticky top-0 z-20 md:hidden bg-surface/80 backdrop-blur-md border-b border-outline-variant/10 px-4 py-3 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <button 
          onClick={onMenuClick}
          aria-label="Menu"
          className="p-2 -ml-2 text-secondary hover:text-on-surface transition-colors"
        >
          <Menu size={24} />
        </button>
        <span className="font-display font-black text-lg text-navy tracking-tight">
          {orgName}
        </span>
      </div>

      <div className="flex items-center gap-2">
        <button className="p-2 text-secondary hover:text-on-surface transition-colors">
          <Search size={20} />
        </button>
        <UserMenu size="sm" />
      </div>
    </header>
  );
};

export default TopAppBar;
